import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const createOrganization = async <T extends Record<string, unknown>>({
  query,
  data: { salesforceId, ...restData },
  domain,
  headers,
}: FetchRequestArgs & { data: { salesforceId: string } }): Promise<
  ReturnType<typeof fetchRequest>
> =>
  fetchRequest<T>({
    data: {
      salesforceID: salesforceId,
      ...restData,
    },
    domain,
    endpoint: '/organizations',
    headers,
    method: HTTPMethod.POST,
    query,
  });
